import React, { useEffect, useRef, useState } from 'react'
import { Apiurl, parseData,SetLocalStorageStringify } from '../utils/page';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from "react-router-dom";

import { useGoogleLogin } from '@react-oauth/google';
import LoginModal from '../../Components/LoginModal/LoginModal';



const ReferralCode = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    const [urlId, setUrlId] = useState(null);

    useEffect(() => {
      if (typeof window !== 'undefined') {
        const id = window.location.pathname
        setUrlId(id);
      }
    }, []);
    const router = useNavigate();
    const [showLoginModal, setShowLoginModal] = useState(false);
    
    const handleShow = () => {
        setShowLoginModal(true)
    }
    const handleClose = () => {
        setShowLoginModal(false)

    }
    // login api
    const loginApi = (userDetail) => {
        const data = {}
        data.email = userDetail?.email;
        data.name = userDetail?.name;
        data.image = userDetail?.picture;
        data.ReferByUserCode=urlId?.split("/")?.[2]
        const options = {
            method: "POST",
            headers: {
                "accept": "*/*",
                'Content-Type': 'application/json',
            },
            data: JSON.stringify(data),
            url: `${Apiurl()}/api/Customer/Login`
        };
        axios(options)
            .then((data) => {
                router("/")
                const token = parseData(data?.data?.result);
                const user = jwtDecode(token?.Token);
                SetLocalStorageStringify("UserDetail", JSON.stringify(token));
                SetLocalStorageStringify("User", JSON.stringify(user));
                SetLocalStorageStringify("AuthToken", token?.Token);
            })
            .catch((error) => {
            });
    }
    const handleLogin = useGoogleLogin({
        onSuccess: async ({ access_token }) => {
            const userInfo = await axios.get(
                'https://www.googleapis.com/oauth2/v3/userinfo',
                { headers: { Authorization: `Bearer ${access_token}` } },
            );
            loginApi(userInfo?.data);

        },
    });

    useEffect(()=>{
handleShow();
    },[])

    return (
        <div>
            <LoginModal showLoginModal={showLoginModal} setShowLoginModal={setShowLoginModal} handleClose={handleClose} handleLogin={handleLogin} />

        </div>
    )
}

export default ReferralCode
